import React, { useEffect } from 'react';
import { POLICY_NAMES } from '../../config';
import { getCookies } from '../../services/config.service';
import { downloadPdf } from '../../utils/downloadUtils';

const DownloadCookiesPolicy = () => {
  const downloadCookies = async () => {
    const { status, data: response } = await getCookies();
    if (status === 200) {
      await downloadPdf({ blob: response, fileName: POLICY_NAMES.COOKIES });
      setTimeout(() => {
        window.close();
      }, 10);
    }
  };

  useEffect(() => {
    downloadCookies();
  }, []);
  return <></>;
};
DownloadCookiesPolicy.propTypes = {};
DownloadCookiesPolicy.defaultProps = {};

export default DownloadCookiesPolicy;
